import { Box, BoxProps, TableHeadProps, TableRowProps } from "@chakra-ui/react";
import { DataTable } from "@picovico/ui";
import { useState } from "react";
import { useAppSelector } from "store";
import { useGetUserPurchaseHistoryQuery } from "store/services/user";
import { UserPurchaseHistoryDTO } from "types/api";

interface TicketHistoryProps {
  tableContainerProps?: BoxProps;
  tHeadProps?: TableHeadProps;
  tRowProps?: TableRowProps;
}

export interface TicketHistoryTabProps {
  ticketHistoryTabProps?: TicketHistoryProps;
}

function TicketHistory({ ticketHistoryTabProps }: TicketHistoryTabProps) {
  const defaultColor = useAppSelector(
    // @ts-expect-error ignore this since it is used for optional chaining
    (state) => state.config.site_theme.colors.background,
  );
  const [page, setPage] = useState(1);
  const { data, isLoading } = useGetUserPurchaseHistoryQuery(
    {
      search: "history",
      page_size: 10,
      page,
    },
    { refetchOnMountOrArgChange: true },
  );
  const {tableContainerProps, tRowProps, tHeadProps} = ticketHistoryTabProps || {}
  const columnSchema = [
    {
      id: "S.N",
      accessorFn: (v: unknown, i: number) => i + 1,
      header: "S.N",
    },
    {
      id: "movie",
      accessorKey: "movie",
      header: "Movie",
    },
    {
      id: "cinema_hall",
      accessorKey: "cinema_hall",
      header: "Cinema Hall",
    },
    {
      id: "screen",
      accessorKey: "screen",
      header: "Screen",
    },
    {
      id: "seats",
      accessorKey: "seats",
      header: "Seats",
    },
    {
      id: "ticket_code",
      accessorKey: "ticket_code",
      header: "Ticket Code",
    },
    {
      id: "transaction_code",
      accessorKey: "transaction_code",
      header: "Transaction Code",
    },
    {
      id: "payment_date",
      accessorFn: (v: UserPurchaseHistoryDTO) => {
        return v.payment_date.split("T")[0];
      },
      header: "Payment Date",
    },
  ];

  return (
    <Box
      overflowX="auto"
      w={{
        base: "xs",
        md: "full",
        xl: "full",
      }}
      maxW="100%"
      p={{ base: 0, md: 4 }}
      {...tableContainerProps}
    >
      <DataTable
        columnSchema={columnSchema}
        data={data?.data?.records || []}
        isLoading={isLoading}
        activePage={page}
        handlePageChange={(p) => setPage(p)}
        pageCount={data?.data?.total_pages || 0}
        tRowProps={{
          background: defaultColor.nav,
          _hover: { backgroundColor: defaultColor.navHover ?? "surface.100" },
          ...tRowProps
        }}
        tHeadProps={{...tHeadProps}}
      />
    </Box>
  );
}

export default TicketHistory;
